import React from 'react'
import { Collection } from '@/types/codegen-contentful'
import { GetProjectTilesQuery } from '@/types/codegen-federation'
import { ReactFCC } from '@/types/react'

interface AboutContextType {
  impact: Collection
  tiles: GetProjectTilesQuery
  numberOfGuildMembers: string
}

interface AboutContextProps extends AboutContextType {
  children: React.ReactNode
}

const AboutContext = React.createContext<AboutContextType>({
  impact: {} as Collection,
  tiles: {},
  numberOfGuildMembers: '250K',
})

export const AboutContextProvider: ReactFCC<AboutContextProps> = ({
  children,
  impact,
  tiles,
  numberOfGuildMembers,
}) => {
  const value = { impact, tiles, numberOfGuildMembers }

  return <AboutContext.Provider value={value}>{children}</AboutContext.Provider>
}

export function useAboutContext() {
  return React.useContext(AboutContext)
}
